<svg
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	><path
		d="M6 12H12M18 12H12M12 12V6M12 12V18"
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	></path></svg
>
